import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Dashboard from './components/Dashboard';
import { PageSkeleton } from './components/ui/Skeleton';
import { ErrorBoundary } from './components/ui/ErrorBoundary';

const HomePage = lazy(() => import('./pages/HomePage'));
const ExamsPage = lazy(() => import('./pages/ExamsPage'));
const BillingPage = lazy(() => import('./pages/BillingPage'));
const ExamPage = lazy(() => import('./pages/ExamPage'));
const StartExamPage = lazy(() => import('./pages/StartExamPage'));
const ExamDetailPage = lazy(() => import('./pages/ExamDetailPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'));
const EmbedExamPage = lazy(() => import('./pages/EmbedExamPage'));
const QuestionBankPage = lazy(() => import('./pages/QuestionBankPage'));
const QuestionBankDetailPage = lazy(() => import('./pages/QuestionBankDetailPage'));
const CommandCenterPage = lazy(() => import('./pages/admin/CommandCenterPage'));

const App: React.FC = () => {
  useEffect(() => {
    document.title = 'InstantExam';
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-gray-50"><PageSkeleton /></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dashboard/*" element={<Dashboard />}>
              <Route path="home" element={<HomePage />} />
              <Route path="exams" element={<ExamsPage />} />
              <Route path="exams/:examId" element={<ExamDetailPage />} />
              <Route path="banks" element={<QuestionBankPage />} />
              <Route path="banks/:bankId" element={<QuestionBankDetailPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="admin" element={<CommandCenterPage />} />
            </Route>
            <Route path="/embed/:url" element={<EmbedExamPage />} />
            <Route path="/exam/:url" element={<ExamPage />} />
            <Route path="/exam/:url/start" element={<StartExamPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiePolicyPage />} />
          </Routes>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
